import useProfileAPI from 'features/profile2.0/hooks/useProfileAPI';
import useAuth from 'hooks/useAuth';
import React, { useEffect } from 'react';

const withGetProfileOccupation = (Component) => {
  const GetProfileOccupationComponent = (props) => {
    const { token } = useAuth();
    const { getProfileOccupationRequest } = useProfileAPI();

    useEffect(() => {
      (async () => {
        getProfileOccupationRequest(token);
      })();
    }, []);

    const newProps = {
      ...props,
    };
    return <Component {...newProps} />;
  };
  return GetProfileOccupationComponent;
};

export default withGetProfileOccupation;
